import { QUERY_CLIENT } from 'src/constants/query-client/queryClient';
import { AUTH_TOKEN_STORAGE_KEY } from 'src/pages/Login/constants';
import { CookieHelper } from './helpers';

export const signOutFn = () => {
  QUERY_CLIENT.clear();

  CookieHelper.delete(AUTH_TOKEN_STORAGE_KEY);
};
